import { useIsGlobalTaxonomy } from 'modules/global-topic/common/global-topic/hooks/use-is-global-taxonomy'

import type { ISearchTerritoryPageSelector } from './search-territory-page-selector.types'

export const useSearchTerritoryPageSelectorModel = (): ISearchTerritoryPageSelector => {
  const { isGlobalTaxonomyWorkspace, isGlobalTaxonomyEnabled, isQueryInformationAvailable } = useIsGlobalTaxonomy()

  return { isGlobalTaxonomyWorkspace, isGlobalTaxonomyEnabled, isQueryInformationAvailable }
}
